import { Redirect, Route, Switch } from 'react-router-dom'
import {
  IonApp,
  IonPage,
  IonIcon,
  IonLabel,
  IonRouterOutlet,
  IonTabBar,
  IonTabButton,
  IonTabs,
  setupIonicReact,
  IonContent
} from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router'
import { ellipse, square, triangle } from 'ionicons/icons';
import ProfileSetup from './pages/ProfileSetup'
import ChatRoom from './pages/ChatRoom'
import Onboarding from './pages/Onboarding'
import StreamingPage from './pages/VideoAvatar'

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

/* Theme variables */
import './theme/variables.css';
import './theme/custom.css';

// import custom font
// Supports weights 300-900
// import '@fontsource/rubik';
// import '@fontsource-variable/rubik';

setupIonicReact();

const App: React.FC = () => (
  <IonApp>
    <IonReactRouter>
      <IonRouterOutlet>
        <Switch>
          {/*<Route exact path="/tab1">
            <Tab1 />
          </Route>*/}
          <Route exact path="/">
            <IonPage>
              <Onboarding />
            </IonPage>
          </Route>

          <Route exact path="/chatroom/:subroom">
            <IonPage>
              <ChatRoom />
            </IonPage>
          </Route>

          <Route exact path="/streaming">
            <IonPage>
              <StreamingPage />
            </IonPage>
          </Route>

          </Switch>
          {/*<Route exact path="/streaming" component={StreamingPage} />*/}
          <Route path="/profilesetup" component={ProfileSetup}/>

      </IonRouterOutlet>
    </IonReactRouter>
  </IonApp>
);

export default App;
